// frontend/src/features/tasks/DayPicker.tsx

import { Group, UnstyledButton, Text } from '@mantine/core';
import { DAYS_OF_WEEK } from '@/types/task';
import classes from './DayPicker.module.css';

interface DayPickerProps {
  selectedDays: number[];
  onChange: (days: number[]) => void;
  disabled?: boolean;
}

export function DayPicker({ selectedDays, onChange, disabled }: DayPickerProps) {
  const toggleDay = (day: number) => {
    if (disabled) return;

    if (selectedDays.includes(day)) {
      onChange(selectedDays.filter((d) => d !== day));
    } else {
      onChange([...selectedDays, day].sort());
    }
  };

  return (
    <Group gap="xs">
      {DAYS_OF_WEEK.map((day) => {
        const isSelected = selectedDays.includes(day.value);
        return (
          <UnstyledButton
            key={day.value}
            onClick={() => toggleDay(day.value)}
            className={classes.dayButton}
            data-selected={isSelected || undefined}
            disabled={disabled}
            title={day.fullLabel}
            aria-label={day.fullLabel}
            aria-pressed={isSelected}
          >
            <Text size="sm" fw={isSelected ? 600 : 400}>
              {day.label}
            </Text>
          </UnstyledButton>
        );
      })}
    </Group>
  );
}
